import { useState, useEffect } from 'react';

const InstallPWA = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      // Previne o prompt padrão
      e.preventDefault();
      setSupportsPWA(true);
      setPromptInstall(e);
      
      // Verifica se o usuário já ignorou anteriormente
      const userChoice = localStorage.getItem('pwaInstall');
      if (!userChoice) {
        setIsOpen(true);
      }
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!promptInstall) {
      return;
    }
    
    promptInstall.prompt();
    
    const { outcome } = await promptInstall.userChoice;
    if (outcome === 'accepted') {
      console.log('Usuário aceitou a instalação');
    }
    setIsOpen(false);
  };

  const handleClose = () => {
    setIsOpen(false);
    localStorage.setItem('pwaInstall', 'ignored');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 p-4 z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-sm mx-auto relative">
        <h3 className="text-lg font-medium text-gray-900">
          Instale nosso aplicativo
        </h3>
        <p className="mt-2 text-sm text-gray-500">
          Instale Meu Esporte para ter uma experiência melhor e acesso rápido em seu dispositivo.
        </p>
        <div className="mt-4 flex space-x-3">
          <button
            onClick={handleInstall}
            className="inline-flex justify-center px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700"
          >
            Instalar
          </button>
          <button
            onClick={handleClose}
            className="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
          >
            Agora não
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPWA;
